import { Controller } from "@hotwired/stimulus"
import debounce from "debounce"
import { get } from "@lib/requests"

// Connects to data-controller="client-form"
export default class extends Controller {

  static targets = ["type", "organisationFields", "organisationName", "nameLabel", "similarClients"]
  
  static values = { resource: { type: String } }
  
  initialize() {
    this.debounceNameLookup = debounce(this.nameLookup.bind(this), 450)
  }
  
  get formType() {
    return this.typeTarget.value
  }

  get companyForm() {
    return this.formType === "organisation"
  }
  
  changeType(e) {
    if (this.companyForm) {
      this.nameLabelTarget.innerHTML = "Nom de la personne réprésentante *"
      this.organisationFieldsTarget.classList.remove("hidden")
      setTimeout(() => {
        this.organisationNameTarget.focus()
      }, 100)
    } else {
      this.nameLabelTarget.innerHTML = "Nom *"
      this.organisationFieldsTarget.classList.add("hidden")
    }
  }

  onNameInput(e) {
    this.debounceNameLookup(e.target.value)
  }

  async nameLookup(name) {
    if (name.length < 3) {
      return this.similarClientsTarget.innerHTML = ""
    } else {
      const placeholderText = document.createElement("p")
      let path = `/clients/search_similar?name=${name}`
      if (this.hasResourceValue) path += `&resource=${this.resourceValue}`
      placeholderText.style.fontSize = "0.8em"
      placeholderText.innerHTML = "Recherche en cours..."
      this.similarClientsTarget.appendChild(placeholderText)
      await get(path, { responseKind: "turbo-stream" })
    }
  }

  closeSuggestions() {
    this.similarClientsTarget.innerHTML = ""
    this.nameTarget.focus()
  }
  
}
